import {
  enrolSuccess,
  getEnrollsSuccess,
  getSingleEnrollSuccess,
  isPending,
  enrolFail,
} from "./enrolmentSlice"
import enrolAPI from "../../apis/enrollAPI" //	createNewEnrol,fetchEnrols, updateEnrol, deleteAEnrol
import { toast } from "react-toastify"

export const newEnrollmentAction = (obj) => async (dispatch) => {
  const {
    amount,
    dueDate,
    paidDate,
    transactionId,
    types,
    _id: preEnrolId,
    fName,
    email,
    paymentMethod,
    sendPaymentReceivedEmail,
    status,
    params,
    ...otherDetails
  } = obj

  const installmentObj = {
    status,
    amount,
    dueDate,
    paidDate,
    transactionId,
    types,
    fName,
    email,
    preEnrolId,
    paymentMethod,
    sendPaymentReceivedEmail,
  }

  try {
    const response = await enrolAPI.createNewEnrol({
      ...otherDetails,
      fName,
      email,
      preEnrolId,
      sendPaymentReceivedEmail,
    })

    if (response.result._id && types === "installment") {
      const { _id } = response.result

      try {
        const result = await enrolAPI.addInstallment({ _id, ...installmentObj })
        if (result._id) {
          console.log("installment added successfully")
        }
      } catch (error) {
        console.log(error)
      }
    }

    response.status === "success"
      ? dispatch(fetchEnrolsAction(params)) &&
        toast.success(response.message) &&
        dispatch(enrolSuccess(response.result))
      : toast.warn(response.message) && dispatch(enrolFail())
  } catch (error) {
    console.log(error)
  }
}

export const fetchEnrolsAction = (params) => async (dispatch) => {
  dispatch(isPending())

  if (params !== "branch=all") {
    const result = await enrolAPI.fetchLocationEnrols(params)
    result.status === "success"
      ? dispatch(getEnrollsSuccess(result.result)) &&
        toast.success(result.message)
      : toast.warn(result.message) && dispatch(enrolFail())
    return
  }

  const result = await enrolAPI.fetchEnrols()

  result.status === "success"
    ? dispatch(getEnrollsSuccess(result.result)) &&
      toast.success(result.message)
    : toast.warn(result.message) && dispatch(enrolFail())
}

export const fetchEnrolsByLocationAction = (params) => async (dispatch) => {
  dispatch(isPending())

  const result = await enrolAPI.fetchLocationEnrols(params)

  result.status === "success"
    ? dispatch(getEnrollsSuccess(result.result)) &&
      toast.success(result.message)
    : toast.warn(result.message) && dispatch(enrolFail())
}

export const fetchSingleEnrolAction = (_id) => async (dispatch) => {
  if (!_id) return

  dispatch(isPending())

  const result = await enrolAPI.fetchEnrols(_id)

  result.status === "success"
    ? dispatch(getSingleEnrollSuccess(result.result)) &&
      dispatch(enrolSuccess(result))
    : toast.warn(result.message) && dispatch(enrolFail())
}

export const deleteEnrolAction = (_id) => async (dispatch) => {
  dispatch(isPending())

  const result = await enrolAPI.deleteAEnrol(_id)

  result.status === "success"
    ? dispatch(fetchEnrolsAction()) && toast.success(result.message)
    : toast.warn(result.message)
}

export const updateEnrolmentAction = (_id, update) => async (dispatch) => {
  if (!_id) return

  const { params, ...rest } = update
  dispatch(isPending())
  const result = await enrolAPI.updateEnrol(_id, rest)

  result.status === "success"
    ? dispatch(enrolSuccess(result.result)) &&
      toast.success("Enrolment information and status updated successfully") &&
      dispatch(fetchEnrolsAction(params))
    : toast.warn("Something went wrong! Please try again later.") &&
      dispatch(enrolFail())
}

export const addNoteFromEnrolment = (obj) => async (dispatch) => {
  dispatch(isPending())

  const { params, ...rest } = obj

  const result = await enrolAPI.addEnrolmentNote(rest)

  result.status === "success"
    ? dispatch(enrolSuccess(result.result)) &&
      toast.success(result.message) &&
      dispatch(fetchEnrolsAction(params))
    : dispatch(enrolFail(result) && toast.warning(result.message))
}

export const addNoteForEnrolmentCancelled = (obj) => async (dispatch) => {
  dispatch(isPending())
  const { params, ...rest } = obj
  const result = await enrolAPI.addEnrolmentCancelNote(rest)

  result.status === "success"
    ? dispatch(enrolSuccess(result.result)) &&
      toast.success(result.message) &&
      dispatch(fetchEnrolsAction(params))
    : dispatch(enrolFail(result) && toast.warning(result.message))
}

export const addInstallmentAction = (obj) => async (dispatch) => {
  dispatch(isPending())
  const { status, result } = await enrolAPI.addInstallment(obj)

  status === "success"
    ? dispatch(getSingleEnrollSuccess(result)) &&
      toast.success("Installment has been added successfully")
    : toast.warn("Something went wrong! Please try again later.")
}

export const removeInstallmentAction = (obj) => async (dispatch) => {
  dispatch(isPending())

  const { status, result } = await enrolAPI.deleteInstallment(obj)

  status === "success"
    ? dispatch(getSingleEnrollSuccess(result)) &&
      toast.success("Installment has been deleted successfully")
    : toast.warn("Something went wrong! Please try again later.")
}
